import type { HomeLiveBroadcast, HomeLivePhase } from "../../SpaceType";

function liveSectionLabel(phase: HomeLivePhase): string {
  if (phase === "live") {
    return "正在直播";
  }
  if (phase === "upcoming") {
    return "即将到来";
  }
  return "直播预告";
}

function liveBadgeLabel(phase: HomeLivePhase): string {
  if (phase === "live") {
    return "LIVE";
  }
  if (phase === "upcoming") {
    return "即将开始";
  }
  return "预告";
}

function liveCountText(live: HomeLiveBroadcast): string | null {
  if (live.phase === "live") {
    if (live.viewerCount == null) {
      return null;
    }
    return `${Number(live.viewerCount).toLocaleString("zh-CN")} 观看`;
  }
  if (live.reserveCount == null) {
    return null;
  }
  return `${Number(live.reserveCount).toLocaleString("zh-CN")} 已预约`;
}

export function SpaceHomeLivePreview(props: { live: HomeLiveBroadcast }) {
  const { live } = props;
  const countText = liveCountText(live);
  const badgeClass =
    live.phase === "live"
      ? "space-home-feed__live-badge"
      : live.phase === "upcoming"
        ? "space-home-feed__live-badge space-home-feed__live-badge--upcoming"
        : "space-home-feed__live-badge space-home-feed__live-badge--preview";

  return (
    <section className="space-home-feed__section" aria-label={liveSectionLabel(live.phase)}>
      <p className="space-home-feed__section-hint">{liveSectionLabel(live.phase)}</p>
      <div className="space-home-feed__hcard">
        <div className="space-home-feed__hcard-thumb">
          <img src={live.coverUrl} alt="" />
          <span className={badgeClass}>{liveBadgeLabel(live.phase)}</span>
        </div>
        <div className="space-home-feed__hcard-body">
          <p className="space-home-feed__hcard-title">{live.title}</p>
          {countText ? <p className="space-home-feed__hcard-meta">{countText}</p> : null}
        </div>
      </div>
    </section>
  );
}
